// extracted by mini-css-extract-plugin
export default {"cardsWrap":"cardBlock_cardsWrap__p5MUX"};